import Head from "next/head";
import React from "react";

import FourZeroFour from "components/fourZeroFour/FourZeroFour/FourZeroFour";
import TabsMenu from "components/global/TabsMenu/TabsMenu";
import ProfileAddresses from "components/profileAddresses/ProfileAddresses/ProfileAddresses";
import CONSTANTS from "config/constants";

const { TITLE, FEATURE_FLAGS } = CONSTANTS;
const { WITH_DELIVERY } = FEATURE_FLAGS;

interface Props {}

const AddressesPage = (props: Props) => {
  if (!WITH_DELIVERY) return <FourZeroFour />;

  return (
    <>
      <Head>
        <title>Direcciones | {TITLE}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <TabsMenu>
        <ProfileAddresses />
      </TabsMenu>
    </>
  );
};

export default AddressesPage;
